module.exports = __webpack_public_path__ + "ir.svg?4eca31ff722fa429de3c2bd75008c79b";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ir.svg
// module id = 1090
// module chunks = 27